export default __webpack_public_path__ + "static/media/temperature.27728fd9.svg";